import { bindActionCreators } from 'redux';

// Actions
export const SELECT_LANGUAGE = 'moblee/site-server/SELECT_LANGUAGE';

// Action creators
export function selectLanguage(payload) {
  return {
    type: SELECT_LANGUAGE,
    payload,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ selectLanguage }, dispatch);
}



// WEBPACK FOOTER //
// ./src/site-render/src/redux/language.js